import common from './common'

//ダウンロード対象の名前を取得
function getDownloadTarget(obj) {
  obj.downloadTarget = common.getStore(obj, 'downloadTarget')
}

//ヘッダロゴの遷移機能有効化
function activeHeaderLogo(obj) {
  obj.$options.parent.isDownloadComplete = true
}

export default {
    common,
    getDownloadTarget,
    activeHeaderLogo
}
